var React = require('react');

function Envelope (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.18164 5.82285L11.2751 13.9059C11.6884 14.2733 12.3113 14.2733 12.7246 13.9059L21.818 5.82285V18.5451C21.818 19.1476 21.3296 19.636 20.7271 19.636H3.27255C2.67006 19.636 2.18164 19.1476 2.18164 18.5451V5.82285ZM3.82369 4.36328H20.176L11.9998 11.631L3.82369 4.36328Z","fill":"white"}));
}

Envelope.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Envelope;

Envelope.default = Envelope;
